import Vue from 'vue'

const QUERY_PARAM_ALIAS_NAMES = {
  q: 'search'
}

export async function searchProducts ({ commit }, { searchConfig }) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })
    commit('setSearchConfig', searchConfig)
    commit('setProducts', null)

    const url = '/v1/products?' + searchConfigToURL(searchConfig)
    const { data } = await Vue.axios({
      url
    })

    commit('setProducts', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

export async function getMoreProducts ({ commit }, url) {
  try {
    commit('shared/setError', null, { root: true })
    commit('shared/setLoading', true, { root: true })

    const { data } = await Vue.axios({
      url
    })

    commit('addProducts', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

export async function getProduct ({ commit }, slug) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })
    commit('setProduct', null)

    const { data } = await Vue.axios({
      method: 'GET',
      url: `/v1/products/${slug}`
    })

    commit('setProduct', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

function getAliasName (key) {
  return QUERY_PARAM_ALIAS_NAMES[key] ?? key
}

function searchConfigToURL (searchConfig) {
  return Object.keys(searchConfig).map(key => {
    const configValue = searchConfig[key]

    key = getAliasName(key)

    if (!Array.isArray(configValue)) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(configValue)
    }

    const configs = []
    for (var value of configValue) {
      configs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value))
    }

    return configs.join('&')
  }).join('&')
}

export async function getHomeProducts ({ commit }) {
  try {
    commit('shared/setError', null, { root: true })
    commit('shared/setLoading', true, { root: true })
    commit('setHomeProducts', null)

    const { data } = await Vue.axios({
      method: 'GET',
      url: '/v1/products/home'
    })

    commit('setHomeProducts', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}
